// @flow

import reducer from './duck';

export * from './duck';
export default reducer;
